/**
 * Campaign authorization, mirrored from the backend (VYV-K7.2).
 *
 * `internal/campaigns/authz.go` gates the campaigns HTTP surface by effect:
 * every staff role may READ campaigns (the sidebar shows /campaigns to reps and
 * pre-sales), but only TENANT_ADMIN, SALES_MANAGER and PLATFORM_ADMIN may
 * persist — create, edit, assign a rep, resolve an audience. The server is the
 * authority; this constant exists so the UI never offers an action that would
 * come back 403.
 *
 * Keep it in sync with campaignWriteRoles in internal/campaigns/authz.go.
 */
export const CAMPAIGN_WRITE_ROLES = ['PLATFORM_ADMIN', 'TENANT_ADMIN', 'SALES_MANAGER'] as const;

/** Whether the given role claim may perform campaign writes. */
export function canWriteCampaigns(role: string | null | undefined): boolean {
  return !!role && (CAMPAIGN_WRITE_ROLES as readonly string[]).includes(role);
}
